import React from 'react';
import VendorList from './VendorList';

const Vendors = () => {
  return <VendorList />;
};

export default Vendors;
